import gql from 'graphql-tag';

export default gql`
    mutation AddEquipments($input: AddEquipmentsInput) {
        addEquipments(input: $input) {
            errors
        }
    }
`;
